import React from "react";
import { Popconfirm, ConfigProvider } from "antd";

import { Colors } from "../../config";

const DefaultPopconfirm = ({
  title,
  description,
  okText = "Yes",
  cancelText = "No",
  onConfirm,
  children,
  ...rest
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: Colors.main,
        },
      }}
    >
      <Popconfirm
        title={title}
        description={description}
        onConfirm={onConfirm}
        okText={okText}
        cancelText={cancelText}
        {...rest}
      >
        {children}
      </Popconfirm>
    </ConfigProvider>
  );
};

export default DefaultPopconfirm;
